import { Button, type ButtonProps as ChakraButtonProps } from "@chakra-ui/react";

interface ButtonStyledProps extends ChakraButtonProps {
  custom?: boolean;
  variant?: ChakraButtonProps["variant"] | "secondary";
}

export function ButtonStyled({ children, size = "sm", custom, ...props }: ButtonStyledProps) {
  const bg = props.variant === "solid" ? "brand.500" : undefined;
  const color = props.variant === "solid" ? "white" : undefined;
  const bgHover = props.variant === "solid" ? "brand-hover" : undefined;
  const bgActive = props.variant === "solid" ? "brand-active" : undefined;

  const styles = custom
    ? {
        bg,
        color,
        _hover: bgHover && { bg: bgHover },
        _active: bgActive && { bg: bgActive },
        borderRadius: "12px",
        fontWeight: "normal",
      }
    : undefined;

  return (
    <Button size={size} {...styles} {...props}>
      {children}
    </Button>
  );
}
